import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../config';
import { HttpResponseStatusCodes } from '@hobt/constants';
import { MasterPoolLoanDetails } from '../types';

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  data: { cmhcAccountNumber: number };
};

const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};

const individualLoanDetailsUrl: string =
  config.validationReviewInventoryApi.urls.loanInventoryTabDetails;
export const getIndividualLoanDetailsData = async ({
  authenticationContext,
  data
}: RequestProps): Promise<MasterPoolLoanDetails | null> => {
  try {
    const requestUrl = `${individualLoanDetailsUrl}/loans/${data.cmhcAccountNumber}/portfolio-loan-detail`;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      requestUrl
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data?.[0]) ||
      {}
    );
  } catch (err) {
    throw new Error('Error getting Individual Loan Details data');
    // eslint-disable-next-line no-unreachable
    return null;
  }
};
